import { siteInfo } from '@/mocks/siteInfo';

export default function StatsSection() {
  const stats = [
    { value: siteInfo.stats.totalUsers, label: '注册用户', icon: 'ri-user-star-line' },
    { value: siteInfo.stats.totalStories, label: '出彩故事', icon: 'ri-file-text-line' },
    { value: siteInfo.stats.monthlyActive, label: '月活跃用户', icon: 'ri-fire-line' },
    { value: siteInfo.stats.totalCategories, label: '内容分类', icon: 'ri-stack-line' },
  ];

  return (
    <section className="py-16 md:py-20 bg-secondary-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20geometric%20pattern%20with%20subtle%20texture%20and%20soft%20flowing%20lines%2C%20dark%20background%2C%20minimalist%20style%2C%20elegant%20and%20sophisticated%20atmosphere&width=1920&height=600&seq=stats-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
            用数字见证出彩力量
          </h2>
          <p className="text-sm md:text-base text-background-50/60">
            每一个数字背后，都是一个正在绽放的普通人不凡故事
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-2xl bg-background-50/10 flex items-center justify-center">
                <i className={`${stat.icon} text-primary-400 text-xl md:text-2xl`}></i>
              </div>
              <p className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-1">
                {stat.value}
              </p>
              <p className="text-sm text-background-50/55">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}